import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { userSelector } from '../../store/session'

const ProtectedAccess = ({ allowedRoles, children }) => {
  const { user } = useSelector(userSelector)
  const userRole = useMemo(() => user?.role?.type, [user])

  const hasAccess = () => user && allowedRoles && allowedRoles.some((role) => role === userRole)
  return hasAccess() ? children : null
}

export default ProtectedAccess
